import React from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Hiring from './Hiring.js';
import * as page from './enum.js';

class Django extends React.Component{

    constructor(props){
       super(props);
       this.state = {
            flag : page.Pages.Home,
            Modal_Check : "Overview",
            Modal_title : "Title",
       }
    }

    Module = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "2px solid";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Module",
        });
    }

    Overview = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "2px solid";
        this.setState({
                    ...this.state,
                    Modal_Check : "Overview",
        });
    }

    Fee = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "2px solid";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Fee",
        });
    }

    Contact = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "2px solid";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Contact",
        });
    }

    Benefits = () => {
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "2px solid";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Benefits",
        });
    }

    Check = () => {
        var ch = this.state.Modal_Check;
        if(ch === "Overview"){
            return (
                <div>
                    <h4 class="mt-2">About Django Training-</h4>
                    <p>ScimoX provides the best industry-relevant content with systematic delivery on the most popular programming
                    Framework Django. Django is a Python-based free and open-source web framework, which follows the model-template-view
                    architectural pattern. It is maintained by the Django Software Foundation, We provide Top faculty with real-time
                    experience in the industry and expert in Django Framework. ScimoX primary goal is to ease the creation of complex.</p>
                    <h4 class="mt-2">Django Course Objective-</h4>
                    <div>The learning objectives of Django course in ScimoX:</div>
                    <div class="mt-1">1. Internalize the concepts & constructs of Django Framework.</div>
                    <div class="mt-1">2. Learn to create your own Websites.</div>
                    <div class="mt-1">3. Master In Django Framework Based Project.</div>
                    <div class="mt-1">4. Master In Database and Data persistence.</div>
                    <div class="mt-1">5. Explain MVC pattern. Create a basic Django app.</div>
                    <div class="mt-1">7. Use HTTP request and response objects. Use URLConf.</div>
                    <div class="mt-1">8. 100% Interview Guarantee.</div>
                </div>
            )
        }else if(ch === "Module"){
            return (
                <div id="Scroll_Me">
                    <h4 class="mt-3">Django Course Syllabus-</h4>
                    <div class="mt-3">1. Basic:</div>
                    <div>Python language introduction, Python 3 basics, Keywords in Python, Namespaces and Scope in Python, Structuring
                        Python Programs, Decision making.</div>
                    <div class="mt-2">2. Input/Output:</div>
                    <div>Taking input in Python, Vulnerability in input() function, Python | end parameter in print(), Python | sep parameter in print().</div>
                    <div class="mt-2">3. Variables:</div>
                    <div>Variables, expression condition and function Maximum possible value of an integer in python, Global and local
                        variables in python Packing and unpacking arguments in python, End parameter in Python.</div>
                    <div class="mt-2">4. Control Flow:</div>
                    <div>Loops, Loops and Control Statements (continue, break and pass) in Python, Looping technique in python, range vs
                    xrange on python, Programs for printing pyramid technique in python Chaining comparison in python, else with for switch
                     function.</div>
                    <div class="mt-2">5. Modules and Packages:</div>
                    <div>Modules, Importing module, Standard Module – sys, Standard Module – OS ,The dir Function, Package Exercise.</div>
                    <div class="mt-2">6. Classes Objects:</div>
                    <div>Introduction classes and objects, Creating Classes, Instance Methods, Special class method, Inheritance, Method
                        overriding, Data handling Exercise.</div>
                    <div class="mt-2">7. Getting started with pandas:</div>
                    <div>Data Frame Basics, Key Operations on Data Frames. function,Matplotlib.</div>
                    <div class="mt-2">8. Plotting for exploratory data analysis (EDA):</div>
                    <div>Data-point, vector, observation,Input variables/features/dimensions/independent variable , Output Variable/
                        Class Label/ Response Label/ ,Scatter-plot: 2D, 3D.</div>
                    <div class="mt-2">9. Advance Library:</div>
                    <div>Multi threading ,Thread, Starting a thread , Threading module,,array,numpy, ,Tkinter programming Tkinter widget.</div>
                    <div class="mt-2">10. Fronted pages:</div>
                    <div>Home,About, Listings,Single Listing, Search, Register,Login, Dashboard (Inquiries).</div>
                    <div class="mt-2">11. Design Specs:</div>
                    <div>Use BTRE logo (Frontend and admin), Branding colors, Mobile Friendly, Social media icons & contact info.</div>
                    <div class="mt-2">12. Listing Page Fields:</div>
                    <div>Title,Address, city, state, zip,Price,Bedrooms,Bathrooms, Square Feet,Main image and 5 other images.</div>
                    <div class="mt-2">13. Possible Future Functionality:</div>
                    <div>Google maps on listing page,Buyer testimonials.</div>
                    <div class="mt-2">14. Functionality Specs:</div>
                    <div>Manage listings, realtors, contact inquiries and website users via admin,Role based users,Display listings in app
                     with pagination,Ability to set listings to unpublished, Search listings by keyword, city, state, bedrooms and price
                     (Homepage & search page), Frontend register/login to track inquiries.</div>
                </div>
            )
        }else if(ch === "Fee"){
            return (
                <div>
                    <h4 class="mt-3">Fee Structure & Course Duration-</h4>
                    <div class="mt-3"><strong>• Course :-</strong> Python Basic and Advance.</div>
                    <div class="mt-3"><strong>• Level :-</strong> Master Certification.</div>
                    <div class="mt-3"><strong>• Batch :-</strong> Weekends, Weekdays.</div>
                    <div class="mt-3"><strong>• Format :-</strong> Class Room Training.</div>
                    <div class="mt-3"><strong>• Course Fee :-</strong> 18000 /-
                    </div>
                    <div class="mt-3"><strong>• Course Duration :-</strong> 45 Days.</div>
                    <div class="mt-3"><strong>• Training Location :-</strong> HazaratGanj Branch, Lucknow.</div>
                </div>
            );
        }else if(ch === "Contact"){
            return (
                <div>
                    <h4 class="mt-3">HR Counsellor-</h4>
                    <div class="mt-2"><strong>Mr. Deepak Kanuajia.</strong></div>
                    <div class="mt-2"><strong>Email :-</strong> Deepak@scimox.com.</div>
                    <div class="mt-2"><strong>Phone :-</strong> (+91) - 7011907181.</div>
                    <h4 class="mt-3">IT Trainer-</h4>
                    <div class="mt-2"><strong>Mr. Rishi Kanuajia.</strong></div>
                    <div class="mt-2"><strong>Email :-</strong> Rishi@scimox.com.</div>
                    <div class="mt-2"><strong>Phone :-</strong> (+91) - 9457384665.</div>
                </div>
            );
        }else if(ch === "Benefits"){
            return (
                <div>
                    <h4 class="mt-3">Benefits of Scimox Training Institute-</h4>
                    <div class="mt-3"><strong>1. 45 days Month Advance Django With Python Course.</strong></div>
                    <div class="mt-2"><strong>2. Syllabus is based on by Job Description.</strong></div>
                    <div class="mt-2"><strong>3. Resume Modification As Per Company Norm.</strong></div>
                    <div class="mt-2"><strong>4. Working on Live Project on Training Module.</strong></div>
                    <div class="mt-2"><strong>6. 1 Year Membership.</strong></div>
                    <div class="mt-2"><strong>7. 100% Interview Guarantee.</strong></div>
                    <div class="mt-2"><strong>8. After Placement Career Mentoring.</strong></div>
                </div>
            );
        }
    }

    render(){
        return (
             <div id="Modal_Content_Color">
                <div class="d-flex justify-content-around">
                    <div onClick={this.Overview}><p id="Bottom_Border_line"><strong>Overview</strong></p></div>
                    <div onClick={this.Module}><p id="Bottom_Border_line1"><strong>Course</strong></p></div>
                    <div onClick={this.Fee}><p id="Bottom_Border_line2"><strong>Fee</strong></p></div>
                    <div onClick={this.Contact}><p id="Bottom_Border_line3"><strong>Contact</strong></p></div>
                    <div onClick={this.Benefits}><p id="Bottom_Border_line4"><strong>Scimox</strong></p></div>
                </div>
                <div>{this.Check()}</div>
             </div>
        );
    }
}

export default Django;